// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-radio-group {
    display: flex;
    flex-direction: column;
    margin: 15px 0;
  }

  .mat-form-field{
    width: 100%;
  }
  
  .example-radio-button {
    margin: 5px;
  }
  
  .checkbox-slides {
    margin-top: 15px;
  }
  
  #SinglePageView .example-radio-group {
    display: flex;
    flex-direction: row;
    margin: 0;
  }
  
  #SinglePageView .form-group {
    margin: 0;
  }
  .location{width: 300px !important;}
  
  .submit-btn{
    width: 130px; 
  }
  @media(max-width:375px){
    .submit-btn{
      width: 80px; 
    }
  }
.example-month-picker .mat-calendar-period-button {
  pointer-events: none;
}

.example-month-picker .mat-calendar-arrow {
  display: none;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvdmlkLXRlc3QuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGFBQWE7SUFDYixzQkFBc0I7SUFDdEIsY0FBYztFQUNoQjs7RUFFQTtJQUNFLFdBQVc7RUFDYjs7RUFFQTtJQUNFLFdBQVc7RUFDYjs7RUFFQTtJQUNFLGdCQUFnQjtFQUNsQjs7RUFFQTtJQUNFLGFBQWE7SUFDYixtQkFBbUI7SUFDbkIsU0FBUztFQUNYOztFQUVBO0lBQ0UsU0FBUztFQUNYO0VBQ0EsVUFBVSx1QkFBdUIsQ0FBQzs7RUFFbEM7SUFDRSxZQUFZO0VBQ2Q7RUFDQTtJQUNFO01BQ0UsV0FBVztJQUNiO0VBQ0Y7QUFDRjtFQUNFLG9CQUFvQjtBQUN0Qjs7QUFFQTtFQUNFLGFBQWE7QUFDZiIsImZpbGUiOiJjb3ZpZC10ZXN0LmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuZXhhbXBsZS1yYWRpby1ncm91cCB7XHJcbiAgICBkaXNwbGF5OiBmbGV4O1xyXG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcclxuICAgIG1hcmdpbjogMTVweCAwO1xyXG4gIH1cclxuXHJcbiAgLm1hdC1mb3JtLWZpZWxke1xyXG4gICAgd2lkdGg6IDEwMCU7XHJcbiAgfVxyXG4gIFxyXG4gIC5leGFtcGxlLXJhZGlvLWJ1dHRvbiB7XHJcbiAgICBtYXJnaW46IDVweDtcclxuICB9XHJcbiAgXHJcbiAgLmNoZWNrYm94LXNsaWRlcyB7XHJcbiAgICBtYXJnaW4tdG9wOiAxNXB4O1xyXG4gIH1cclxuICBcclxuICAjU2luZ2xlUGFnZVZpZXcgLmV4YW1wbGUtcmFkaW8tZ3JvdXAge1xyXG4gICAgZGlzcGxheTogZmxleDtcclxuICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XHJcbiAgICBtYXJnaW46IDA7XHJcbiAgfVxyXG4gIFxyXG4gICNTaW5nbGVQYWdlVmlldyAuZm9ybS1ncm91cCB7XHJcbiAgICBtYXJnaW46IDA7XHJcbiAgfVxyXG4gIC5sb2NhdGlvbnt3aWR0aDogMzAwcHggIWltcG9ydGFudDt9XHJcbiAgXHJcbiAgLnN1Ym1pdC1idG57XHJcbiAgICB3aWR0aDogMTMwcHg7IFxyXG4gIH1cclxuICBAbWVkaWEobWF4LXdpZHRoOjM3NXB4KXtcclxuICAgIC5zdWJtaXQtYnRue1xyXG4gICAgICB3aWR0aDogODBweDsgXHJcbiAgICB9XHJcbiAgfVxyXG4uZXhhbXBsZS1tb250aC1waWNrZXIgLm1hdC1jYWxlbmRhci1wZXJpb2QtYnV0dG9uIHtcclxuICBwb2ludGVyLWV2ZW50czogbm9uZTtcclxufVxyXG5cclxuLmV4YW1wbGUtbW9udGgtcGlja2VyIC5tYXQtY2FsZW5kYXItYXJyb3cge1xyXG4gIGRpc3BsYXk6IG5vbmU7XHJcbn1cclxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/covid-test/covid-test.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;EACA,UAAU,uBAAuB,CAAC;;EAElC;IACE,YAAY;EACd;EACA;IACE;MACE,WAAW;IACb;EACF;AACF;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA,orDAAorD","sourcesContent":[".example-radio-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 15px 0;\r\n  }\r\n\r\n  .mat-form-field{\r\n    width: 100%;\r\n  }\r\n  \r\n  .example-radio-button {\r\n    margin: 5px;\r\n  }\r\n  \r\n  .checkbox-slides {\r\n    margin-top: 15px;\r\n  }\r\n  \r\n  #SinglePageView .example-radio-group {\r\n    display: flex;\r\n    flex-direction: row;\r\n    margin: 0;\r\n  }\r\n  \r\n  #SinglePageView .form-group {\r\n    margin: 0;\r\n  }\r\n  .location{width: 300px !important;}\r\n  \r\n  .submit-btn{\r\n    width: 130px; \r\n  }\r\n  @media(max-width:375px){\r\n    .submit-btn{\r\n      width: 80px; \r\n    }\r\n  }\r\n.example-month-picker .mat-calendar-period-button {\r\n  pointer-events: none;\r\n}\r\n\r\n.example-month-picker .mat-calendar-arrow {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
